// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Glutathione Refill 09.17.26" (b3994eb5-72d4-4393-b845-c56daf1f7067). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiGlutathioneRefillAnswerField } from './questions';

export const mdiGlutathioneRefill: FormType<mdiGlutathioneRefillAnswerField> = {
  name: 'Glutathione Refill',
  validityLength: 25,
  questions: [
    'mdiGlutathioneRefill_changesMedicalHistorySinceLast',
    'mdiGlutathioneRefill_newAllergiesSinceLastPrescription',
    'mdiGlutathioneRefill_diagnosedCancerSinceLastPrescription',
    'mdiGlutathioneRefill_diagnosedLiverKidneyDiseaseSince',
    'mdiGlutathioneRefill_erVisitsHospitalizationsSinceLast',
    'mdiGlutathioneRefill_havingSideEffectsCurrentTreatment',
    'mdiGlutathioneRefill_importantClickAttachedLinkReview',
    'mdiGlutathioneRefill_messageDoctorLetThemKnow',
    'mdiGlutathioneRefill_complete'
  ]
};
